// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"4064":"8d37563af9a48c7ea542","6778":"059c29a40152f2f6afcf","8826":"3c9b523bfa4c4940e4d8"}[chunkId] + ".css";
};